<template>
	<div>
		<button class="element__button element__button--toggle" @click="toggle">{{ $t('toggle') }}</button>

		<input
			ref="input"
			class="element__input"
			:name="name"
			:type="type"
			:inputmode="inputmode"
			:placeholder="placeHolderText"
			:pattern="pattern"
			:maxlength="maxlength"
			v-model="binding"
			required
		/>
		<button v-if="binding !== ''" class="element__button element__button--clear" @click="clear">
			{{ $t('clear') }}
		</button>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

import { resolveStateURI } from '@/tools/storeURIHandler';
import { mutationTypes } from '@/types';
import { getLangValue } from '@/tools/languageValue';
import { uiStates } from '@/tools/viewState';
import { logger } from '@/tools/logger';

export default {
	data() {
		return {
			internalValue: '',
			toggledOn: false,
		};
	},
	props: {
		value: [String, Number, Boolean],
		name: String,
		type: String,
		inputmode: String,
		pattern: String,
		placeholder: Object,
		maxlength: String,
		storeURI: String,
		parentName: String,
	},
	computed: {
		...mapState(['viewState']),
		binding: {
			set(value) {
				this.$store.commit(mutationTypes.setStoreValueByURI, { storeURI: this.storeURI, value });
			},
			get() {
				return resolveStateURI(this.storeURI, this.$store);
			},
		},
		placeHolderText() {
			return getLangValue(this.placeholder);
		},
	},
	methods: {
		...mapMutations([mutationTypes.toggleInViewState, mutationTypes.viewStateSetUiState]),
		keyEvent(event) {
			this.internalValue = this.$refs.input.value;
			this.$emit('keyup', event);
			this.$emit('input', this.$refs.input.value);
		},
		focus() {
			this.$refs.input.focus();
		},
		clear() {
			this.$refs.input.value = '';
			this.internalValue = '';
			this.binding = '';
			this.focus();
			this.$emit('keyup', event);
			this.$emit('input', this.$refs.input.value);
		},
		toggle() {
			logger.log(`Pressed Toggle on ${this.parentName} last State ${this.toggledOn}`);
			this[mutationTypes.toggleInViewState]({ id: this.parentName });

			const { uiState } = this.viewState[this.parentName];
			logger.log('UiState: ', uiState);
			if (uiState !== uiStates.hidden) {
				// this.$refs.input.focus();
				Vue.nextTick(() => {
					this.$refs.input.focus();
					this.toggledOn = true;
				});
			} else {
				Vue.nextTick(() => {
					this.$refs.input.value = '';
					this.internalValue = '';
					this.binding = '';
					this.toggledOn = false;
				});
			}
		},
	},
};
</script>
